/* tslint:disable */
/* eslint-disable */
export enum WorkEventInvitationStatusEnum {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Unanswered = 'UNANSWERED'
}
